import React, { PureComponent } from 'react';
import classNames from 'classnames';

import './index.css';

const titleTextClassname = 'nyl-alert__title__text';
const largeTitleTextClassname = `${titleTextClassname}--large`;

class NylAlert extends PureComponent {
  render() {
    const {
      title,
      body,
      titleTextProps = {},
    } = this.props;

    const { size = 'default' } = titleTextProps;

    return (
      <div className="nyl-alert">
        {title ? (
          <div className="nyl-alert__title">
            {
              typeof title === 'string' ? (
                <h5 className={classNames(titleTextClassname, { [largeTitleTextClassname]: size === 'large' })}>
                  {title}
                </h5>
              ) : title
            }
          </div>
        ) : null}
        {body && <div className="nyl-alert__body">{body}</div>}
      </div>
    );
  }
}

export default NylAlert;
